import { NotificationsScreen } from '../features/notifications/NotificationsScreen'

export function NotificationsPage() {
  return <NotificationsScreen />
}
